module.exports = __webpack_public_path__ + "img/security.b30ee73a.svg";